import React, { Fragment } from 'react';

import { data } from '../../utils/constants';
import {ProjectCard} from '../../components'
import { useTranslation } from "react-i18next";
import { Carousel } from 'react-responsive-carousel';

const SimilarCategory = ({similarProjet}) => {
  const {t} = useTranslation("projets") ;
  return (
    <Fragment>
        <section className="similar-projet py-[90px] lg:py-[115px] flex justify-center">
            <div className="content-wrapper">
                <h2 className="headline-border">{t("relatedProject")}</h2>

                <div className="
               w-[340px] md:w-[884px] lg:w-[1024px] lg:mx-auto pt-[40px]">
                    <Carousel className='w-[340px] md:w-[884px] lg:w-[1024px]'>
                    {
                       similarProjet.map((projet) => {
                        return(
                          <ProjectCard 
                          img={projet.imgs[0]}
                          key={projet.id}
                          projAlt={projet.name}
                          projDesc={projet.description}
                          projId={projet.id}
                          projTitle={projet.name}
                          />
                        )
                       }) 
                    }
                    </Carousel>
                </div>
            </div>
        </section>
    </Fragment>
  )
}

export default SimilarCategory